import React, { Component } from "react";
export default class DotCountingSection extends Component {
  render() {
    var {
      dot_countring_score,
      dot_status_1,
      dot_status_2,
      dot_status_3,
      dot_status_4,
    } = this.props.data;
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-12">
          <div className="row mt-4">
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>1)</b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas/form-b/dot_counting/1.png"}
                  alt="1"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>2)</b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas/form-b/dot_counting/2.png"}
                  alt="2"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>3) </b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas/form-b/dot_counting/3.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>4) </b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas/form-b/dot_counting/4.png"}
                  alt="scorpion"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div>
            <br />
            <span className="fs-19">Score (0-4) </span>
            <input
              type="number"
              disabled
              name="dot_countring_score"
              value={dot_countring_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
